export const Italian = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'è'.toUpperCase(), 'ù'.toUpperCase()],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'ò'.toUpperCase(), 'à'.toUpperCase()],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
]
